module.exports = __webpack_public_path__ + "static/img/shopbag.cf7c39b.png";


//////////////////
// WEBPACK FOOTER
// ./static/shopbag.png
// module id = sX26
// module chunks = 1